/** RESTECH_PROVIDER_CONFIG: add a booking integration with the same create wizard used
 *  on the Integrations tab. Existing integrations are edited from that tab (its edit
 *  dialog); this keeps the preflight item as the entry point for adding one. */
import AddIcon from '@mui/icons-material/Add';
import { Alert, Box, Button } from '@mui/material';
import { useState } from 'react';

import { IntegrationCreateDialog } from '@/features/tour-operators/integrations/IntegrationCreateDialog';

import type { ActionUIProps } from './ActionCustomUI';

export function BookingIntegrationsControl({ topId, toCode, canManage, onChanged }: ActionUIProps) {
  const [open, setOpen] = useState(false);
  return (
    <Box sx={{ mb: 1.5 }}>
      <Alert severity="info" sx={{ mb: 1 }}>
        Add a booking integration with the same wizard used on the Integrations tab; edit or remove
        existing ones from that tab.
      </Alert>
      {canManage && (
        <Button size="small" variant="outlined" startIcon={<AddIcon />} onClick={() => setOpen(true)}>
          Add integration
        </Button>
      )}
      <IntegrationCreateDialog
        open={open}
        toId={topId}
        toCode={toCode}
        onClose={() => setOpen(false)}
        onCreated={() => {
          setOpen(false);
          onChanged();
        }}
      />
    </Box>
  );
}
